var d = (s, e, t) => {
  if (!e.has(s))
    throw TypeError("Cannot " + t);
};
var c = (s, e, t) => (d(s, e, "read from private field"), t ? t.call(s) : e.get(s)), h = (s, e, t) => {
  if (e.has(s))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(s) : e.set(s, t);
}, l = (s, e, t, o) => (d(s, e, "write to private field"), o ? o.call(s, t) : e.set(s, t), t);
import { P as u } from "./Processor-a451ab8e.mjs";
var r;
class g extends u {
  constructor({ url: t, stringifyValue: o }) {
    super({ stringifyValue: o });
    h(this, r, "");
    l(this, r, t);
  }
  send(t) {
    if (t.length) {
      const o = this.processEvents(t), n = JSON.stringify({
        ...this._meter.customAttributes && { labels: this._meter.customAttributes },
        metrics: o
      }), a = navigator && navigator.sendBeacon && navigator.sendBeacon.bind(navigator), i = () => {
        fetch(c(this, r), {
          body: n,
          method: "POST",
          keepalive: !0
        }).catch(console.error);
      };
      try {
        a && a(c(this, r), n) || i();
      } catch {
        i();
      }
    }
  }
}
r = new WeakMap();
export {
  g as default
};
